export type ProviderRefusalCode =
  | "LLM_LOGIN_MISSING"
  | "LLM_LOGIN_EXPIRED"
  | "LLM_LOGIN_KIND_DISABLED"
  | "LLM_PROVIDER_NOT_ALLOWED"
  | "CLAUDE_HARNESS_UNAVAILABLE"
  | "CLAUDE_TURN_BUSY";

export interface ProviderRefusal {
  code: ProviderRefusalCode;
  status: 403 | 409 | 503;
  message: string;
}

const REFUSAL: Record<ProviderRefusalCode, { status: 403 | 409 | 503; message: string }> = {
  LLM_LOGIN_MISSING: { status: 409, message: "This account has no Claude login. Add one under Settings > Agent Provider, or switch this chat to OpenRouter." },
  LLM_LOGIN_EXPIRED: { status: 409, message: "This account's Claude login has expired. Renew it under Settings > Agent Provider, or switch this chat to OpenRouter." },
  LLM_LOGIN_KIND_DISABLED: { status: 503, message: "Claude logins are disabled on this deployment. Switch this chat to OpenRouter." },
  LLM_PROVIDER_NOT_ALLOWED: { status: 403, message: "This workspace cannot use the Claude provider. Switch this chat to OpenRouter." },
  CLAUDE_HARNESS_UNAVAILABLE: { status: 503, message: "Claude is not available yet on this deployment. Try again in a few minutes, or switch this chat to OpenRouter." },
  CLAUDE_TURN_BUSY: { status: 409, message: "Another Claude turn is already running for this account. Wait for it to finish, or switch this chat to OpenRouter." },
};

export function providerRefusal(code: string): ProviderRefusal | null {
  const found = REFUSAL[code as ProviderRefusalCode];
  return found ? { code: code as ProviderRefusalCode, status: found.status, message: found.message } : null;
}

